export var EBookSheetType;
(function (EBookSheetType) {
    EBookSheetType["chapter"] = "chapter";
    EBookSheetType["page"] = "page";
})(EBookSheetType || (EBookSheetType = {}));
export var EBookSheetContentType;
(function (EBookSheetContentType) {
    EBookSheetContentType["images"] = "images";
    EBookSheetContentType["text"] = "text";
    EBookSheetContentType["videos"] = "videos";
})(EBookSheetContentType || (EBookSheetContentType = {}));
